import { Button, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import CityProvinceCountrySelector from "../../designSystem/CityProvinceCountrySelector";
import TextField from "../../designSystem/TextField";
import { defaultNestedValues } from "./companyProfileDtos";

const AddressForm = ({
    title,
    formNamespace,
    handleAddDock,
    readOnly,
    children
}) => {
    const { register, setValue, watch, getValues, clearErrors, formState: { errors } } = useFormContext();
    const sameAddress = watch(`${formNamespace}.sameAsCompanyProfile`, false);
    const disabled = sameAddress;
    const dockIsEditMode = getValues("dockForm.dockID") != null;

    const validateSameAddressData = () => {
        let missing = [];

        const { streetNo, streetName, postalCode, companyProfile } = getValues();
        const { city, province, country } = companyProfile;

        if (!streetNo || streetNo.trim() === "") missing.push("Street No");
        if (!streetName || streetName.trim() === "") missing.push("Street Name");
        if (!postalCode || postalCode.trim() === "") missing.push("Postal Code");

        if (!Array.isArray(city) || city.length === 0) {
            missing.push("City");
        }
        if (province == null || isNaN(province)) {
            missing.push("Province");
        }
        if (country == null || isNaN(country)) {
            missing.push("Country");
        }

        if (missing.length > 0) {
            toast.error(`The following fields are missing: ${missing.join(", ")}`, { position: "top-center" });
        }
        return missing;
    };

    const populateAddressFields = () => {
        const sameAddressData = getValues()
        setValue(`${formNamespace}.streetNo`, sameAddressData.streetNo);
        setValue(`${formNamespace}.streetName`, sameAddressData.streetName);
        setValue(`${formNamespace}.postalCode`, sameAddressData.postalCode);
        setValue(`${formNamespace}.city`, sameAddressData.companyProfile.city);
        setValue(`${formNamespace}.provinceList`, sameAddressData.companyProfile.provinceList);
        setValue(`${formNamespace}.province`, sameAddressData.companyProfile.province);
        setValue(`${formNamespace}.countryList`, sameAddressData.companyProfile.countryList);
        setValue(`${formNamespace}.country`, sameAddressData?.companyProfile?.country);
    };

    const clearFields = () => {
        setValue(`${formNamespace}.streetNo`, "");
        setValue(`${formNamespace}.streetName`, "");
        setValue(`${formNamespace}.postalCode`, "");
        setValue(`${formNamespace}.city`, "");
        setValue(`${formNamespace}.provinceList`, "");
        setValue(`${formNamespace}.province`, "");
        setValue(`${formNamespace}.countryList`, "")
        setValue(`${formNamespace}.country`, "");
    }

    return (
        <Row className="my-2">
            <Col sm={12}>
                <fieldset className="mb-3">
                    <label className="label-heading">{title}</label>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="sameAsCompanyProfile">
                                <Form.Check
                                    disabled={readOnly}
                                    checked={sameAddress}
                                    type="checkbox"
                                    label="Same as company profile"
                                    {...register(`${formNamespace}.sameAsCompanyProfile`, {
                                        onChange: (e) => {
                                            if (e.target.checked) {
                                                const missing = validateSameAddressData();
                                                if (missing.length === 0) {
                                                    populateAddressFields();
                                                    clearErrors([
                                                        `${formNamespace}.streetNo`,
                                                        `${formNamespace}.streetName`,
                                                        `${formNamespace}.postalCode`,
                                                        `${formNamespace}.city`,
                                                        `${formNamespace}.province`,
                                                        `${formNamespace}.country`,
                                                    ]);
                                                } else {
                                                    setValue(`${formNamespace}.sameAsCompanyProfile`, false);
                                                }
                                            } else {
                                                clearFields();
                                            }
                                        },
                                    })}
                                />
                            </Form.Group>
                        </Col>
                        {formNamespace === "dockForm" ? (
                            <div className="d-flex gap-2 justify-content-end">
                                <Button variant="danger" onClick={handleAddDock} >
                                    {dockIsEditMode ? "Save Dock" : "Add Dock"}
                                </Button>
                                {dockIsEditMode ?
                                    <Button variant="outline-danger" onClick={() => {
                                        clearFields();
                                        setValue(`${formNamespace}.dockName`, "");
                                        setValue(`${formNamespace}.dockID`, null);
                                        setValue("dockForm", {
                                            ...defaultNestedValues,
                                            dockName: "",
                                            isPrimary: false
                                        });
                                    }}>
                                        Cancel
                                    </Button>
                                    : null}
                            </div>
                        ) : null}
                    </Row>
                    <Row className="mb-2">
                        {formNamespace === "dockForm" && (
                            <Col sm={1}>
                                <TextField
                                    {...register(`${formNamespace}.dockName`, { required: "Field is Required" })}
                                    error={errors[formNamespace]?.dockName?.message}
                                    label="Dock Name"
                                    readOnly={readOnly}
                                />
                            </Col>
                        )}
                        <Col sm={formNamespace === "dockForm" ? 1 : 2}>
                            <TextField
                                {...register(`${formNamespace}.streetNo`, { required: "Field is Required" })}
                                error={errors[formNamespace]?.streetNo?.message}
                                label="Street"
                                disabled={disabled}
                                readOnly={readOnly}
                            />
                        </Col>
                        <Col sm={2}>
                            <TextField
                                {...register(`${formNamespace}.streetName`, { required: "Field is Required" })}
                                error={errors[formNamespace]?.streetName?.message}
                                label="Street Name"
                                disabled={disabled}
                                readOnly={readOnly}
                            />
                        </Col>
                        <CityProvinceCountrySelector formNamespace={formNamespace} disabled={disabled} readOnly={readOnly} />
                        <Col sm={2}>
                            <TextField
                                {...register(`${formNamespace}.postalCode`, { required: "Field is Required" })}
                                error={errors[formNamespace]?.postalCode?.message}
                                label="Postal Code"
                                disabled={disabled}
                                readOnly={readOnly}
                            />
                        </Col>
                    </Row>
                    {children}
                </fieldset>
            </Col>
        </Row >
    );
};

export default AddressForm;
